export const RemittanceStatus = [
  'Requested',
  'Assigned',
  'Distributing',
  'Delivered',
  'Canceled',
]
